const resize = {
  name: "resize",
  path: "resize",
  title: "resize",
  description: "Utilities for controlling the CSS resize property.",
  value: {
    "resize": {
      "resize-none": "none",
      "resize": "both",
      "resize-y": "vertical",
      "resize-x": "horizontal"
    }
  },
  exampleData: [
    {
      title: "resize, resize-x, resize-y, resize-none",
      description: "Set the resize behavior of an element:",
      example: {
        code: `<textarea class="resize w-64 h-24 border rounded p-2" placeholder="resize: both"></textarea>
<textarea class="resize-x w-64 h-24 border rounded p-2" placeholder="resize: horizontal"></textarea>
<textarea class="resize-y w-64 h-24 border rounded p-2" placeholder="resize: vertical"></textarea>
<textarea class="resize-none w-64 h-24 border rounded p-2" placeholder="resize: none"></textarea>`
      }
    }
  ],
  htmlData: [
    {
      title: "Resize",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">resize</code> utilities to control the resize property of an element.
      </p>
      <div class="flex gap-6">
        <textarea class="resize w-64 h-24 border border-color-gray-200 rounded p-2" placeholder="resize: both"></textarea>
        <textarea class="resize-x w-64 h-24 border border-color-gray-200 rounded p-2" placeholder="resize: horizontal"></textarea>
        <textarea class="resize-y w-64 h-24 border border-color-gray-200 rounded p-2" placeholder="resize: vertical"></textarea>
        <textarea class="resize-none w-64 h-24 border border-color-gray-200 rounded p-2" placeholder="resize: none"></textarea>
      </div>
      `
    }
  ]
};

export default resize;


<div className="sr-only resize resize-x resize-y resize-none">

</div>